<template>
  <nav class="disease-type-v2-nav">
    <ul
      ref="nav"
      :style="`width: ${width}px;${cssText}`"
      @touchstart="touchstart"
      @touchmove="touchmove"
      @touchend="touchend"
    >
      <li
        v-for="(item, idx) in list"
        :key="`ztn_${idx}`"
        :style="`width: ${item.width}px`"
        :class="idx === value ? 'active' : ''"
        @click="gotoTab(idx)"
      >
        {{ item.insuranceName }}
      </li>
      <li :style="`width: ${list[value].width}px; transform: translate3d(${tagLeft}px, 0, 0)`">
        <em />
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      width: window.innerWidth,
      move: 0,
      tagLeft: 0,
      cssText: '',
      lefts: [0]
    }
  },
  watch: {
    list: {
      handler(v) {
        if (!v || !v.length) return
        let WW = 0
        v.forEach(item => {
          let ww = 0
          item.insuranceName.split('').forEach(letter => {
            ww += /[\u2E80-\uFE4F（）]/.test(letter) ? 15 : 8
          })
          item.width = ww + 20
          WW += ww + 20
          this.lefts.push(WW - 30)
        })
        this.isScroll = WW > window.innerWidth
        this.maxLeft = WW - window.innerWidth
        this.width = WW
      },
      immediate: true
    },
    value: {
      handler(v) {
        let left = this.lefts[v]
        this.tagLeft = left === 0 ? 0 : left + 30
        left = left > this.maxLeft ? this.maxLeft : left
        this.cssText = `transform: translate(-${left}px, 0);transition: all 0.3s 0s`
        this.move = -left
      },
      immediate: true
    }
  },
  methods: {
    gotoTab(idx) {
      this.$emit('input', idx)
    },
    touchstart(ev) {
      if (!this.isScroll) return
      const touch = ev.touches[0]
      this.startX = touch.pageX
    },
    touchmove(ev) {
      if (!this.isScroll) return
      const touch = ev.touches[0]
      const currentX = touch.pageX
      this.dis = currentX - this.startX + this.move
      this.dis = Math.min(this.dis, 0)
      this.dis = Math.max(this.dis, -this.maxLeft)
      this.cssText = `transform: translate(${this.dis}px, 0)`
    },
    touchend() {
      if (!this.isScroll) return
      this.move = this.dis
    }
  }
}
</script>
<style>
@import './diseaseTypeNew.css';
</style>